const handleFlashClose = (event) => {
  const button = event.target.closest('.close-message');
  if (!button) return;

  event.preventDefault();

  const flashMessage = button.closest('.flash-message');
  if (flashMessage) flashMessage.remove();
};

document.addEventListener('click', handleFlashClose);
